const selectProduct = (state) => state.product.product;
const selectParts = (state) => state.product.parts;
const selectIsFetchingProduct = (state) => state.product.isFetching;
const selectError = (state) => state.product.error;

export {selectProduct, selectParts, selectIsFetchingProduct, selectError};
